
import { defineComponent } from "vue";

export default defineComponent({
  name: "menu",
  props: {
    type: String
  },
  methods: {
    logout(){
      localStorage.removeItem('access-token')
      setTimeout(() => {
          this.$router.push('login')
      });
    },
    nav(type:any){
      this.$router.push(type)
    }
  },
  mounted(){

  }
});
